import { signInWithPopup, OAuthProvider } from "firebase/auth";
import { auth } from "../services/firebase";
import { AppLayout, Button, Container, ContentLayout, Header } from "@cloudscape-design/components";
import { AppHeader } from "../commons/header";

export default function Login() {
    const loginWithMicrosoft = async () => {
        const provider = new OAuthProvider("microsoft.com");

        provider.setCustomParameters({
            tenant: "17e9d4a2-1c8d-40d2-af3f-929da470e0c7"
        })

        try {
            await signInWithPopup(auth, provider);
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <div>
            <AppLayout
                headerVariant="high-contrast"
                navigationHide
                toolsHide
                content={
                    <ContentLayout
                        headerVariant="high-contrast"
                        header={
                            <AppHeader
                                breadcrumbs={[
                                    { text: "Provider Capability Map", href: "/" },
                                    { text: "Login", href: "/" },
                                ]}
                                header={"Provider Capability Map"}
                                description="Hier kann gepflegt werden, welcher Provider, welche Technical Service Offerings erbringen könnte"
                            />
                        }
                    >
                        <Container
                            header={
                                <Header
                                    variant="h2"
                                    description="Melde dich per Single Sign On an"
                                >
                                    Login
                                </Header>
                            }
                        >
                            <Button onClick={loginWithMicrosoft}>Mit Microsoft anmelden</Button>
                        </Container>
                    </ContentLayout>
                }
            />
        </div>
    );
}
